import { MODE, type Token, USDC, WETH } from '@/plugins/erc20';
import { mode } from 'viem/chains';

const goatERC20Tokens: Token[] = [
  MODE,
  USDC,
  WETH,
  // DAI
  {
    chains: {
      [mode.id]: {
        contractAddress: '0xE7798f023fC62146e8Aa1b36Da45fb70855a77Ea',
      },
    },
    decimals: 18,
    name: 'Dai Stablecoin',
    symbol: 'DAI',
  },
  // USDT
  {
    chains: {
      [mode.id]: {
        contractAddress: '0xf0F161fDA2712DB8b566946122a5af183995e2eD',
      },
    },
    decimals: 6,
    name: 'Tether USD',
    symbol: 'USDT',
  },
  // WBTC
  {
    chains: {
      [mode.id]: {
        contractAddress: '0xcDd475325D6F564d27247D1DddBb0DAc6fA0a5CF',
      },
    },
    decimals: 8,
    name: 'Wrapped BTC',
    symbol: 'WBTC',
  },
];

export default goatERC20Tokens;
